import InputField from 'components/fields/InputField';

export const PaymentModal = ({
  isOpen,
  onClose,
  paymentInfo,
  onSubmit,
  errors,
}) => {
  if (!isOpen) return null;

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="w-full max-w-lg rounded-xl bg-white p-6 dark:bg-navy-800">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-navy-700 dark:text-white">
            Make Payment
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {paymentInfo.selectedPaymentInfo && (
          <div className="mb-4 rounded-lg bg-gray-50 p-4 dark:bg-navy-900">
            <h6 className="mb-2 text-sm font-semibold text-gray-600 dark:text-gray-400">
              Payment Details
            </h6>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              Course: {paymentInfo.selectedPaymentInfo.courseName}
            </p>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              Batch: {paymentInfo.selectedPaymentInfo.batchNumber}
            </p>
            <p className="mt-2 text-lg font-bold text-brand-500">
              Amount: ₹
              {parseFloat(paymentInfo.paymentData.amountPaid).toLocaleString()}
            </p>
          </div>
        )}

        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <InputField
              label="Payment Date"
              type="date"
              name="paymentDate"
              value={paymentInfo.paymentData.paymentDate}
              onChange={paymentInfo.handlePaymentChange}
              className="w-full rounded-xl border border-gray-200 p-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
            />
          </div>
          <div>
            <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
              Payment Type
            </label>
            <select
              name="paymentType"
              value={paymentInfo.paymentData.paymentType}
              onChange={paymentInfo.handlePaymentChange}
              className="mt-2 w-full rounded-xl border border-gray-200 p-3.5 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
            >
              <option value="">Select Payment Type</option>
              <option value="PhonePe">PhonePe</option>
              <option value="Google Pay">Google Pay</option>
              <option value="Credit Card">Credit Card</option>
              <option value="Debit Card">Debit Card</option>
              <option value="PhonePe">Bajaj Finance</option>
              <option value="Google Pay">Northern Arc</option>
              <option value="Credit Card">Shop Se</option>
              <option value="Debit Card">Dili Finance</option>
            </select>
          </div>
          <div className="md:col-span-2">
            <InputField
              label={
                ['PhonePe', 'Google Pay'].includes(
                  paymentInfo.paymentData.paymentType
                )
                  ? 'UPI Transaction ID'
                  : ['Credit Card', 'Debit Card'].includes(
                      paymentInfo.paymentData.paymentType
                    )
                  ? 'Card Transaction Number'
                  : 'Transaction Number'
              }
              type="text"
              name="txnNumber"
              value={paymentInfo.paymentData.txnNumber}
              onChange={paymentInfo.handlePaymentChange}
              className="w-full rounded-xl border border-gray-200 p-3 text-sm dark:border-white/10 dark:bg-navy-800 dark:text-white"
              placeholder={
                ['PhonePe', 'Google Pay'].includes(
                  paymentInfo.paymentData.paymentType
                )
                  ? 'Enter UPI Transaction ID'
                  : ['Credit Card', 'Debit Card'].includes(
                      paymentInfo.paymentData.paymentType
                    )
                  ? 'Enter Card Transaction Number'
                  : 'Enter Transaction Number'
              }
            />
          </div>
        </div>

        {errors.length > 0 && (
          <div className="mt-4 text-sm text-red-500">
            {errors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </div>
        )}

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="rounded-xl border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-700 transition-colors hover:bg-gray-100 dark:border-gray-600 dark:bg-navy-800 dark:text-white dark:hover:bg-navy-700"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={errors.length > 0}
            className="rounded-xl bg-brand-500 px-6 py-2 font-semibold text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Submit Payment
          </button>
        </div>
      </div>
    </div>
  );
};
